<div class="w-full flex justify-end absolute top-0 left-0">
    <button class="back-button z-10 me-3" (click)="returnToList()">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round">
            <!-- <polyline points="15 18 9 12 15 6"></polyline> -->
            <!-- close icon -->
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
    </button>
</div>
<div class="w-full slider">
    <iea-slider class="flex-auto z-0" [slides]="galleryService.all()" [active]="activeArtBoardIndex()" (activeChange)="activeChange($event)"></iea-slider>
</div>
